import React from "react";
import MaskedInput from "react-text-mask";
import { MASK_CEP, MASK_ZIP_CODE, removeMask } from "../../../helper/mask";
import { Select, Form, Row, Col, Input,Checkbox,Tooltip } from "antd";

import { InfoCircleOutlined } from "@ant-design/icons";

import InputOrSearch from "./Input-search";
import services from "./../services";
import useSecurityContext from "../../../component/Security/useSecurityContext";
import { Permissions } from "../../../Constantes/permissions.constants";

const BRASIL = "BRASIL";
const Endereco = ({ nome, form, status }) => {
  const [modoSomenteLeitura, setModoSomenteLeitura] = React.useState(true);
  const [opcoesUf, setOpcoesUf] = React.useState([]);
  const [opcoesPais, setOpcoesPais] = React.useState([]);
  const [opcoesCidade, setOpcoesCidade] = React.useState([]);
  const { hasPermission } = useSecurityContext();
  const [brasilSelecionado, setBrasilSelecionado] = React.useState(true);
  const [cepEncontrado, setCepEncontrado] = React.useState(false);
  const [ufSelecionada, setUfSelecionada] = React.useState(false);
  const [cidadeSelecionada, setCidadeSelecionada] = React.useState(false);

  const [opcoesBairro, setOpcoesBairro] = React.useState([]);

  const [semNumero, setSemNumero] = React.useState(false);

  const getPermissaoPais = () =>
    hasPermission({ hasAnyRole: Permissions.RECADASTRAMENTO.TODOS_PAIS });

  const carregarOpcoesUf = () => {
    services
      .obterUF("")
      .then((response) => response?.data)
      .then((data) =>
        data?.map(({ id, sigla }) => ({ value: sigla, label: sigla }))
      )
      .then(setOpcoesUf);
  };

  const carregarOpcoesCidade = (uf) => {
    services
      .obterCidades(uf)
      .then((response) => response.data.content)
      .then((data) =>
        data.map(({ id, nome }) => ({ value: nome, label: nome,id: id  }))
      )
      .then(setOpcoesCidade);
  };

  const carregarOpcoesPais = () => {
    if (getPermissaoPais()) {
      services
        .obterPais()
        .then((response) => response.data)
        .then((data) => data.map(({ nome }) => ({ value: nome, label: nome })))
        .then(setOpcoesPais)
        .catch(console.error);
    } else {
      setOpcoesPais([{ value: BRASIL, label: BRASIL }]);
    }
  };

  const handleConsultaCep = (e) => {
    const cep = removeMask(e.target.value);
    if (brasilSelecionado && cep.length === 8) {
      carregarCEP(cep).catch(() => {
        form.setFieldsValue({
          [nome]: {
            logradouro: "",
            uf: "",
            cidade: "",
            bairro: { nome: "" },
          },
        });
        setCepEncontrado(false);
        setUfSelecionada(false);
        setCidadeSelecionada(false);
      });
    }
  };

  const carregarCEP = async (valor) => {
    const endereco = await services.getEndereco(valor);
  
    setCepEncontrado(true);
  
     const tipo = endereco.tipo?.trim() ?? "";
     const nomeLogradouro = endereco.logradouro?.trim() ?? "";

     const logradouro = `${tipo} ${nomeLogradouro}`.trim();
    //const logradouro = `${endereco.tipo} ${endereco.logradouro}`;
  
    form.setFieldsValue({
      [nome]: {
        //logradouro: logradouro,
        uf: endereco.uf,
        cidade: endereco.cidade,
        bairro: endereco.bairro, // agora é string (consistente com o Form.Item)
      },
    });
  
    await carregarOpcoesCidade(endereco.uf);
    setUfSelecionada(true);
  
    const cidadeObj = (await services.obterCidades(endereco.uf))
      .data.content.find((c) => c.nome === endereco.cidade);
  
    if (cidadeObj?.id) {
      await carregarOpcoesBairro(cidadeObj.id);
      setCidadeSelecionada(true);
    }
  };

  /*const carregarCEP = (valor) => {
    return services.getEndereco(valor).then((endereco) => {
      setCepEncontrado(true);
      const logradouro = `${endereco.tipo} ${endereco.logradouro}`;
      form.setFieldsValue({
        [nome]: {
          logradouro: logradouro,
          uf: endereco.uf,
          cidade: endereco.cidade,
          bairro: { nome: endereco.bairro },
        },
      });
    });
  };*/

  /*const controleInicialCEP = (valor) => {
    if (valor !== undefined && valor.length === 8) {
      carregarCEP(valor).catch(() => {
        setCepEncontrado(false);
        carregarOpcoesCidade(form.getFieldValue([nome, "uf"]));
        setUfSelecionada(true);
        setCidadeSelecionada(true);
      });
    }
  };*/

  const controleInicialCEP = (valor) => {
    if (valor !== undefined && valor.length === 8) {
      carregarCEP(valor).catch(() => {
        setCepEncontrado(false);
  
        const uf = form.getFieldValue([nome, "uf"]);
        const cidade = form.getFieldValue([nome, "cidade"]);
  
        if (uf) {
          carregarOpcoesCidade(uf);
          setUfSelecionada(true);
        }
  
        if (cidade) {
          setCidadeSelecionada(true);
        }
      });
    }
  };

  const controleInicialPais = (valor) => {
    if (valor === BRASIL) setBrasilSelecionado(true);
    else setBrasilSelecionado(false);
  };

  const resetarCamposEndereco = () => {
    form.setFieldsValue({
      [nome]: {
        cep: "",
        logradouro: "",
        complemento: "",
        uf: "",
        cidade: "",
        bairro: "",
        //correspondencia:false,
      },
    });
  };

  const handleAlteracaoPais = (value) => {
    if (value === undefined || value === BRASIL) setBrasilSelecionado(true);
    else setBrasilSelecionado(false);
    resetarCamposEndereco();
    setCepEncontrado(true);
  };

  const handleAlteracaoUF = (value) => {
    if (brasilSelecionado) {
      setUfSelecionada(true);
      carregarOpcoesCidade(value);
    }
  };

  const handleAlteracaoCidade = (value,option) => {
    if (brasilSelecionado) {
      setCidadeSelecionada(true);
      carregarOpcoesBairro(option.id || value);
    }
  };

  React.useEffect(() => {
    controleInicialPais(form.getFieldValue([nome, "pais"]));
  }, [status]);

  React.useEffect(() => {
    if (brasilSelecionado)
      controleInicialCEP(form.getFieldValue([nome, "cep"]));
  }, [brasilSelecionado]);

  React.useEffect(() => {
    carregarOpcoesUf();
    carregarOpcoesPais();
  }, []);

  React.useEffect(() => {
    const numeroAtual = (form.getFieldValue([nome, "numero"]) || "")
      .toString()
      .trim()
      .toUpperCase();

    // Marca checkbox apenas se for S/N ou equivalentes
    const semNum = ["","S/N", "SEM NUMERO", "SEM NÚMERO","SEM"].includes(numeroAtual);
    setSemNumero(semNum);

    // Só sobrescreve o valor se for realmente S/N
    if (semNum) {
      form.setFieldValue([nome, "numero"], "S/N");
    }
  }, [form, form.getFieldValue([nome, "numero"])]);

  /*React.useEffect(() => {
    const cidadeNome = form.getFieldValue([nome, "cidade"]);
  
    if (cidadeNome && opcoesCidade.length > 0) {
      const cidadeObj = opcoesCidade.find(
        (c) => c.value === cidadeNome
      );
  
      if (cidadeObj?.id) {
        setUfSelecionada(true);
        setCidadeSelecionada(true);
        carregarOpcoesBairro(cidadeObj.id);
      }
    }
  }, [opcoesCidade]);*/

  React.useEffect(() => {
    const cidadeNome = form.getFieldValue([nome, "cidade"]);
  
    if (cidadeNome && opcoesCidade.length > 0) {
      const cidadeObj = opcoesCidade.find(
        (c) => c.value === cidadeNome
      );
  
      if (cidadeObj?.id) {
        setUfSelecionada(true);
        setCidadeSelecionada(true);
  
        carregarOpcoesBairro(cidadeObj.id);
      }
    }
  }, [opcoesCidade]);

  const carregarOpcoesBairro = (cidadeId) => {
    services
      .obterBairros(cidadeId)
      .then((response) => response.data.content)
      .then((data) =>
        data.map(({ nome }) => ({
          value: nome,
          label: nome,
        }))
      )
      .then(setOpcoesBairro)
      .catch(() => setOpcoesBairro([]));
  };

  React.useEffect(() => {
    const cidade = form.getFieldValue([nome, "cidade"]);
  
    if (cidade && opcoesCidade.length > 0) {
      const cidadeObj = opcoesCidade.find((c) => c.value === cidade);
  
      if (cidadeObj?.id) {
        setUfSelecionada(true);
        setCidadeSelecionada(true);
        carregarOpcoesBairro(cidadeObj.id);
      }
    }
  }, [opcoesCidade, form]);

  return (
    <div>
      <Row>
        <Col span={4}>
          <Form.Item
          disabled={modoSomenteLeitura}
            name={[nome, "pais"]}
            label="País"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Selecione..."
              options={opcoesPais}
              showSearch
              onChange={handleAlteracaoPais}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name={[nome, "cep"]}
            label={brasilSelecionado ? "CEP" : "ZIP Code"}
            rules={[
              { required: true },
              { validator: brasilSelecionado ? Endereco.Validator : null },
            ]}
            disabled={modoSomenteLeitura}
          >
            <MaskedInput
            disabled={modoSomenteLeitura}
              type="text"
              guide={false}
              autoComplete="off"
              mask={brasilSelecionado ? MASK_CEP : MASK_ZIP_CODE}
              className="ant-input"
              onBlur={handleConsultaCep}
            />
          </Form.Item>
        </Col>
        <Col span={14}>
          <Form.Item
            name={[nome, "logradouro"]}
            label="Endereço"
            preserve={true}
            rules={[{ required: true }, { type: "string", max: 255 }]}
          >
            <Input
              type="text"
              maxLength="300"
              disabled={cepEncontrado && brasilSelecionado || modoSomenteLeitura}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item
            name={[nome, "complemento"]}
            label="Complemento"
            rules={[{ required: true }, { max: 255 }]}
          >
            <Input type="text" />
          </Form.Item>
        </Col>
        <Col span={2}>
          <Form.Item
            name={[nome, "uf"]}
            label="UF"
            rules={[{ required: true }, { max: 2 }]}
          >
            <InputOrSearch
              options={opcoesUf}
              disabled={cepEncontrado && brasilSelecionado || modoSomenteLeitura}
              onChange={handleAlteracaoUF}
              showSearch
              showInput={!brasilSelecionado}
            />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[nome, "cidade"]}
            label="Cidade"
            rules={[{ required: true }]}
          >
            <InputOrSearch
              options={opcoesCidade}
              disabled={(cepEncontrado || !ufSelecionada) && brasilSelecionado || modoSomenteLeitura}
              onChange={handleAlteracaoCidade}
              showSearch
              showInput={!brasilSelecionado}
            />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            name={[nome, "bairro"]}
            label="Bairro"
            rules={[{ required: true }, { max: 72 }]}
          >
          <InputOrSearch
            options={opcoesBairro}
            disabled={(cepEncontrado || !cidadeSelecionada) && brasilSelecionado || modoSomenteLeitura}
            showSearch
            showInput={!brasilSelecionado}
          />
            {/*<Input
              disabled={
                (cepEncontrado || !cidadeSelecionada) && brasilSelecionado
              }
            />*/}
          </Form.Item>
        </Col>
        
        <Col span={4}>
          <Form.Item
            name={[nome, "quadra"]}
            label="Quadra"
            rules={[{ required: true }, { max: 255 }]}
          >
            <Input type="text" />
          </Form.Item>
        </Col>

        {/*<Col span={4}>
          <Form.Item
            name={[nome, "lote"]}
            label="Lote"
            rules={[
              { max: 255 },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const numero = getFieldValue([nome, "numero"]);
                  if (value || numero) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Informe Lote ou Número"));
                },
              }),
            ]}
          >
            <Input type="text" />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            name={[nome, "numero"]}
            label="Número"
            rules={[
              { max: 255 },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const lote = getFieldValue([nome, "lote"]);
                  if (value || lote) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Informe Lote ou Número"));
                },
              }),
            ]}
          >
            <Input type="text" />
          </Form.Item>
        </Col>*/}

<Row gutter={16}>
          {/* Lote */}
          <Col span={12}>
            <Form.Item
              name={[nome, "lote"]}
              label={
                <span>
                  Lote <span style={{ color: "red" }}>**</span>
                </span>
              }
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const numero = getFieldValue([nome, "numero"]);
                    if (numero === "S/N" && !value) {
                      return Promise.reject(
                        new Error("Lote obrigatório quando Número for S/N")
                      );
                    }
                    if (!value && (!numero || numero === "")) {
                      return Promise.reject(
                        new Error("Informe Lote ou Número")
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input
                onBlur={() => {
                  form.validateFields([
                    [nome, "numero"],
                    [nome, "lote"],
                  ]);
                }}
              />
            </Form.Item>
          </Col>

          {/* Número */}
          <Col span={12}>
            <Form.Item
              label={
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <span>
                    Número <span style={{ color: "red" }}>**</span>
                  </span>
                  <Checkbox
                    checked={semNumero}
                    onChange={(e) => {
                      const marcado = e.target.checked;
                      setSemNumero(marcado);

                      // Se marcado, define o valor "S/N", senão limpa
                      form.setFieldValue(
                        [nome, "numero"],
                        marcado ? "S/N" : ""
                      );

                      // Valida campos
                      form.validateFields([
                        [nome, "numero"],
                        [nome, "lote"],
                      ]);
                    }}
                  >
                    S/N
                  </Checkbox>
                </div>
              }
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const lote = getFieldValue([nome, "lote"]);
                    if ((!value || value === "") && (!lote || lote === "")) {
                      return Promise.reject(
                        new Error("Informe Lote ou Número")
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              {!semNumero && (
                <Form.Item
                  name={[nome, "numero"]}
                  noStyle
                  rules={[
                    {
                      required: true,
                      message: "Informe o número ou marque S/N",
                    },
                  ]}
                >
                  <Input
                    maxLength={10}
                    value={form.getFieldValue([nome, "numero"]) || ""}
                    onChange={(e) => {
                      // Permite apenas números se checkbox não estiver marcado
                      if (!semNumero) {
                        const somenteNumeros = e.target.value.replace(
                          /\D/g,
                          ""
                        );
                        form.setFieldValue(
                          [nome, "numero"],
                          somenteNumeros
                        );
                      }
                    }}
                    onBlur={() =>
                      form.validateFields([
                        [nome, "numero"],
                        [nome, "lote"],
                      ])
                    }
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>
        </Row>

        {/*<Col span={6} style={{ display: "flex", alignItems: "center" }}>
          <Form.Item
            name={[nome, "correspondencia"]}
            valuePropName="checked"
            noStyle
          >
            <Checkbox>Permitir contato/correspondência</Checkbox>
          </Form.Item>

          <Tooltip
              title="Caso seja necessário, essa ação autoriza a realização de contato por meio dos dados informados, incluindo telefone, e-mail ou correspondência."
          >
            <InfoCircleOutlined style={{ marginLeft: 8, color: "#1890ff" }} />
          </Tooltip>
        </Col>*/}


      </Row>
    </div>
  );
};

Endereco.Validator = (_, value = "") =>
  value.replace(/\D/g, "").length < 8 && value.replace(/\D/g, "").length > 0
    ? Promise.reject(new Error("CEP Incorreto"))
    : Promise.resolve();

export default Endereco;
